export class GetAdviceDataModel {

    public contactNumber: string;
    public emailAddress: string;
    public firstName: string;
    public lastName: string;
}
